import api from "../lib/axios";

export const resendTicket = async (id) => {
  const res = await api.get(`/ticket/resendTicket/${id}`, {
    headers: {
      "Content-Type": "application/json",
    },

    validateStatus: () => true,
  });
  if (res.status >= 400) {
    const error = new Error(res?.data?.message || res?.data?.errorMessage || "Failed to resend ticket");
    error.response = res;
    throw error;
  }
  return res;
};

export const checkExistsEmailNumber = async (
  eventId,
  ticketId,
  data,
  type,
) => {
  const res = await api.post(
    `/ticket/checkExists/${type}`,
    { eventId, ticketId, data },
    {
      headers: {
        "Content-Type": "application/json",
      },
      validateStatus: () => true,
    },
  );

  return res;
};

export const verifyTicket = async (params, token) => {
  const res = await api.get(`/ticket/verify-ticket`, {
    params,
    headers: {
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const uploadTicketFile = async (file, token, options = {}) => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await api.post("/ticket/upload/file", formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
    transformRequest: [(d) => d],
    ...options,
  });
  return res;
};

export const updateTicketOfUser = async (id, fields, token) => {
  const res = await api.put(
    "/ticket/updateTicketOfUser",
    { id, fields },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    }
  );
  return res;
};

export const deleteTicketRegistration = async (ticketId, submissionId, status, token) => {
  const res = await api.delete(`/ticket/deleteTicketRegistration/${ticketId}/${submissionId}/${status}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getTicketPdf = async (id) => {
  const res = await api.post(`/ticket/print/${id}`, { printTemplate: "ticket", checkIn: false, method: 1 }, {
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
    responseType: "arraybuffer",
  });
  return res;
};

export const getRegisteredTicketForEvent = async (type, eventId) => {
  const res = await api.get(`/ticket/getRegisteredTicketForEvent/${type}`, {
    params: {
      event_id: eventId,
    },
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const deleteUserRegistrationOfEvent = async (submissionId, deleteReason = null) => {
  const res = await api.delete(`/ticket/deleteUserRegistrationOfEvent`, {
    params: {
      submission_id: submissionId,
    },
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
    data: { deleteReason },
  });
  return res;
};

export const getAllTicketsForEvent = async (eventId, type, token) => {
  const path =
    type === "team"
      ? `/ticket/getAllTicketsForEvent/team/?event_id=${eventId}`
      : type === "exhibitor"
        ? `/ticket/getAllTicketsForEvent/exhibitor/?event_id=${eventId}`
        : `/ticket/getAllTicketsForEvent?event_id=${eventId}`;
  const res = await api.get(path, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const verifyTicketPrint = async (submissionId, member) => {
  const res = await api.get(`/ticket/print/verify/${submissionId}?member=${member}`);
  return res;
};

export const getRegistrationModalSection = async (params, token) => {
  const res = await api.get(`/ticket/registrationModalSection`, {
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};

export const getMultipleTicketsPdf = async (submissionIds) => {
  const res = await api.post(
    `/ticket/getMultipleTicketsPdf`,
    { submission_ids: submissionIds },
    {
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
      responseType: "arraybuffer",
    }
  );
  return res;
};

export const downloadTicketPdf = async (id) => {
  const res = await api.get(`/ticket/downloadTicketPdf/${id}`, {
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const linkPreRegistration = async (preRegId, onspotId, force = false) => {
  const res = await api.post(`/ticket/linkPreRegistration`, {
    pre_registration_submission_id: preRegId,
    onspot_submission_id: onspotId,
    force,
  });
  return res;
};

export const getEventTickets = async (url) => {
  const res = await api.get(url, {
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getDynamicFieldsByTicketId = async (eventId, ticketId) => {
  const res = await api.get(`/ticket/getDynamicFieldsByTicketId`, {
    params: { event_id: eventId, ticket_id: ticketId },
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const reserveTicketAvailability = async (body) => {
  const res = await api.post("/ticket/reserveAvailability", body);
  return res;
};

export const releaseTicketAvailability = async (body) => {
  const res = await api.post("/ticket/releaseAvailability", body);
  return res;
};

export const submitTicketForms = async (formData, type) => {
  const url =
    type && type !== "normal"
      ? `/ticket/submitTicketForms/${type}`
      : "/ticket/submitTicketForms";
  const res = await api.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    withCredentials: true,
  });
  return res;
};

export const getRegisteredTicketForTicket = async (ticketId) => {
  const res = await api.get(`/ticket/getRegisteredTicketForTicket/${ticketId}`, {
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getRegisteredTicketForEventExport = async (type, params) => {
  let url;
  if (type === "team") {
    url = `/ticket/getRegisteredTicketForEvent/team`;
  } else if (type === "exhibitor") {
    url = `/ticket/getRegisteredTicketForEventV2/2`;
  } else {
    url = `/ticket/getRegisteredTicketForEvent`;
  }
  const res = await api.get(url, {
    params,
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getGroups = async (eventId, search) => {
  const params = { event_id: `${eventId ?? ""}` };
  const normalizedSearch = (search || "").trim();
  if (normalizedSearch) params.search = normalizedSearch;
  const res = await api.get(`/ticket/getGroups`, { params });
  return res;
};

export const deleteGroup = async (groupId) => {
  const res = await api.delete(`/ticket/deleteGroup/${groupId}`);
  return res;
};

export const createGroup = async (body) => {
  const res = await api.post(`/ticket/createGroup`, body);
  return res;
};

export const getGroupMembers = async (groupId, params = {}) => {
  const res = await api.get(`/ticket/getGroupMembers/${groupId}`, { params });
  return res;
};

export const printGroupTicketsBackend = async (payload, token) => {
  const res = await api.post(`/ticket/printGroupTicketsBackend`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return res;
};

export const getTicketClassById = async (ticketId) => {
  const res = await api.get(`/ticket/getTicketClassById/${ticketId}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return res;
};

export const importTicketData = async (ticketId, formData) => {
  const res = await api.post(`/ticket/importData/${ticketId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res;
};

export const importDataEvent = async (eventId, formData) => {
  const res = await api.post(`/ticket/importDataEvent/${eventId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res;
};

export const updateFoodAccessForUser = async (submissionId, foodData, token) => {
  const res = await api.put(
    `/ticket/updateFoodAccessForUser/${submissionId}`,
    { foodData },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
  return res;
};

export const updateKitAccessForUser = async (submissionId, kitData, token) => {
  const res = await api.put(
    `/ticket/updateKitAccessForUser/${encodeURIComponent(submissionId)}`,
    { kitData },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
  return res;
};

export const updateAllowMultiplePrintTickets = async (submissionId, allowMultiplePrintTickets, token) => {
  const res = await api.put(
    `/ticket/updateAllowMultiplePrintTickets/${submissionId}`,
    { allow_multiple_print_tickets: allowMultiplePrintTickets },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
  return res;
};

export const updateRegistrationTicketClass = async (payload, token) => {
  const res = await api.put(
    `/ticket/updateRegistrationTicketClass`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
  return res;
};

export const getPreRegistrationByParent = async (submissionId, token) => {
  const res = await api.get(`/ticket/getPreRegistrationByParent/${submissionId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return res;
};

export const getTicketAllDataAsEvent = async (eventId) => {
  const res = await api.get(`/ticket/getTicketAllDataAsEvent`, {
    params: { event_id: eventId },
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getEventSaleAndTicketData = async (eventId, token, options = {}) => {
  const res = await api.get(`/ticket/getEventSaleAndTicketData`, {
    params: { event_id: eventId },
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
    ...options,
  });
  return res;
};

export const adjustTicketClassSaleWindows = async (eventId, tickets, token) => {
  const res = await api.put(
    `/ticket/adjustTicketClassSaleWindows`,
    { event_id: eventId, tickets },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    },
  );
  return res;
};

export const deleteTicketClass = async (ticketClassId) => {
  const res = await api.delete(
    `/ticket/deleteTicketClass?ticketClassId=${ticketClassId}`,
  );
  return res;
};

export const getTicketDataAsEvent = async (eventId) => {
  const res = await api.get(`/ticket/getTicketDataAsEvent`, {
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
    params: { event_id: eventId },
  });
  return res;
};

export const getRegisteredTicketForEventSponsor = async (params, token, options = {}) => {
  const headers = { "Content-Type": "application/json", "ngrok-skip-browser-warning": "true" };
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await api.get("/ticket/getRegisteredTicketForEvent/sponsor", { params, headers, ...options });
  return res;
};

export const getAllTicketsForEventSponsor = async (eventId) => {
  const res = await api.get(`/ticket/getAllTicketsForEvent/sponsor/?event_id=${eventId}`);
  return res;
};

export const getAllTicketsForEventTeam = async (params) => {
  const res = await api.get(`/ticket/getAllTicketsForEvent/team/`, {
    params,
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const submitTicketForm = async (formData) => {
  const res = await api.post(`/ticket/submitTicketForm`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res;
};

export const verifyTicket2 = async (submission_id, event_id, type, token) => {
  const res = await api.get(`/ticket/verify-ticket`, {
    params: {
      submission_id,
      event_id,
      type,
    },
    headers: {
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const verifyTicket3 = async (params) => {
  const res = await api.get(`/ticket/verify-ticket`, {
    params,
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
    validateStatus: () => true,
  });
  return res;
};

export const updateTicketOfUser2 = async (body) => {
  const res = await api.put(
    "/ticket/updateTicketOfUser",
    body,
    {
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    }
  );
  return res;
};

export const deleteTicketRegistration2 = async (ticketId, submissionId, status, token) => {
  const res = await api.delete(
    `/ticket/deleteTicketRegistration/${ticketId}/${submissionId}/${status}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    },
  );
  return res;
};

export const getRegisteredTicketForEvent2 = async (eventId, type) => {
  let url;
  if (type === "team") {
    url = `/ticket/getRegisteredTicketForEvent/team`;
  } else if (type === "exhibitor") {
    url = `/ticket/getRegisteredTicketForEvent/exhibitor`;
  } else {
    url = `/ticket/getRegisteredTicketForEvent`;
  }
  const res = await api.get(url, {
    params: {
      event_id: eventId,
    },
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const updateTicketOfUser3 = async (payload) => {
  const res = await api.put(`/ticket/updateTicketOfUser`, payload, {
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const deleteTicketRegistration3 = async (ticketId, submissionId, status, token) => {
  const res = await api.delete(`/ticket/deleteTicketRegistration/${ticketId}/${submissionId}/${status}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const deleteUserRegistrationOfEvent2 = async (submissionId, deleteReason = null) => {
  const res = await api.delete(`/ticket/deleteUserRegistrationOfEvent`, {
    params: {
      submission_id: submissionId,
    },
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
    data: { deleteReason },
  });
  return res;
};

export const updateTicketOfUser4 = async (payload) => {
  const res = await api.put(
    "/ticket/updateTicketOfUser",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    }
  );
  return res;
};

export const getAllTicketsForEvent2 = async (type, eventId, token) => {
  const path =
    type === "team"
      ? `/ticket/getAllTicketsForEvent/team/?event_id=${eventId}`
      : type === "exhibitor"
        ? `/ticket/getAllTicketsForEvent/exhibitor/?event_id=${eventId}`
        : `/ticket/getAllTicketsForEvent?event_id=${eventId}`;
  const res = await api.get(path, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getTicketPdf2 = async (id, member = null) => {
  return printTicketPdf(id, {
    printTemplate: "ticket",
    checkIn: false,
    method: 1,
    ...(member ? { member } : {}),
  });
};

export const printTicketPdf = async (id, options = {}) => {
  const res = await api.post(`/ticket/print/${id}`, options, {
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
    responseType: "arraybuffer",
  });
  return res;
};

export const getBadgeImage = async (id, params = {}) => {
  const res = await api.get(`/ticket/badge/image/${id}`, {
    params,
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getBadgePdf = async (id, member = null) => {
  return printTicketPdf(id, {
    printTemplate: "print",
    checkIn: false,
    method: 1,
    ...(member ? { member } : {}),
  });
};

export const getCertificatePrintPdf = async (id, member = null) => {
  return printTicketPdf(id, {
    printTemplate: "forCertificatePrint",
    checkIn: false,
    method: 1,
    ...(member ? { member } : {}),
  });
};

export const regenerateTicketAssets = async (submissionId, token) => {
  const res = await api.post(
    `/ticket/regenerateTicket/${submissionId}`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    },
  );
  return res;
};

export const regenerateBulkTicketAssets = async (payload, token) => {
  const res = await api.post(
    `/ticket/regenerate-bulk`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
      validateStatus: () => true,
    },
  );
  if (res.status >= 400) {
    const error = new Error(res?.data?.message || "Failed to start regeneration");
    error.response = res;
    throw error;
  }
  return res;
};

export const deleteTicketRegistration4 = async (ticketId, submissionId, status, deleteReason, token) => {
  const res = await api.delete(
    `/ticket/deleteTicketRegistration/${ticketId}/${submissionId}/${status}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
      data: {
        deleteReason: deleteReason || null,
      },
    }
  );
  return res;
};

export const updateTicketOfUser5 = async (payload) => {
  const res = await api.put("/ticket/updateTicketOfUser", payload, {
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getEventTickets2 = async (url) => {
  const res = await api.get(url, {
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getDynamicFieldsByTicketId2 = async (eventId, ticketId) => {
  const res = await api.get(
    `/ticket/getDynamicFieldsByTicketId?event_id=${eventId}&ticket_id=${ticketId}`,
  );
  return res;
};

export const reserveTicketAvailability2 = async (body) => {
  const res = await api.post("/ticket/reserveAvailability", body, {
    headers: { "Content-Type": "application/json" },
  });
  return res;
};

export const releaseTicketAvailability2 = async (body) => {
  const res = await api.post("/ticket/releaseAvailability", body, {
    headers: { "Content-Type": "application/json" },
  });
  return res;
};

export const submitTicketForms2 = async (type, formData) => {
  const url =
    type && type !== "normal"
      ? `/ticket/submitTicketForms/${type}`
      : "/ticket/submitTicketForms";
  const res = await api.post(url, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    withCredentials: true,
  });
  return res;
};

export const getTicketPdf4 = async (id) => {
  const res = await api.get(`/ticket/site/getTicketPdf/${id}`);
  return res;
};

export const uploadTicketFile2 = async (file, token) => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await api.post("/ticket/upload/file", formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getTicketPdf5 = async (id) => {
  const res = await api.get(`/ticket/site/getTicketPdf/${id}`);
  return res;
};

export const getDynamicFieldsByTicketId4 = async (eventId, ticketId, token) => {
  const res = await api.get(`/ticket/getDynamicFieldsByTicketId`, {
    params: { event_id: eventId, ticket_id: ticketId },
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getAllTicketsForEvent3 = async (eventId) => {
  const res = await api.get(`/ticket/getAllTicketsForEvent?event_id=${eventId}`);
  return res;
};

export const getDynamicFieldsByTicketId5 = async (eventId, ticketId) => {
  const res = await api.get(`/ticket/getDynamicFieldsByTicketId?event_id=${eventId}&ticket_id=${ticketId}`, {
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getAllTicketsForEvent4 = async (eventId, type) => {
  const typePath = type ? `/${type}` : "";
  const res = await api.get(`/ticket/getAllTicketsForEvent${typePath}?event_id=${eventId}`, {
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getRegistrationModalSection2 = async (params, token) => {
  const res = await api.get(`/ticket/registrationModalSection`, {
    params,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getAllTicketsForEvent5 = async (eventId, type, token) => {
  const path =
    type === "speaker"
      ? `/ticket/getAllTicketsForEvent/speaker/?event_id=${eventId}`
      : type === "sponsor"
        ? `/ticket/getAllTicketsForEvent/sponsor/?event_id=${eventId}`
        : type === "exhibitor"
          ? `/ticket/getAllTicketsForEvent/exhibitor/?event_id=${eventId}`
          : type === "team"
            ? `/ticket/getAllTicketsForEvent/team/?event_id=${eventId}`
            : `/ticket/getAllTicketsForEvent?event_id=${eventId}`;
  const res = await api.get(path, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getTicketPdf6 = async (submissionId, token) => {
  const res = await api.get(`/ticket/site/getTicketPdf/${submissionId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const linkPreRegistration3 = async (body, token) => {
  const res = await api.post(`/ticket/linkPreRegistration`, body, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getRegisteredTicketForEvent3 = async (url, params, config = {}) => {
  const res = await api.get(url, {
    params,
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
    ...config,
  });
  return res;
};

export const getRegisteredTicketForEvent4 = async (event_id) => {
  const res = await api.get(`/ticket/getRegisteredTicketForEvent`, {
    params: { event_id },
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getAllTicketsForEvent6 = async (eventId) => {
  const res = await api.get(`/ticket/getAllTicketsForEvent?event_id=${eventId}`, {
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getAllTicketsForEvent7 = async (eventId, suffix = "") => {
  const res = await api.get(
    `/ticket/getAllTicketsForEvent${suffix}?event_id=${eventId}`,
    {
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    },
  );
  return res;
};

export const getRegisteredTicketForEvent5 = async (type, params) => {
  const res = await api.get(`/ticket/getRegisteredTicketForEvent/${type}`, {
    params,
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getAllTicketsForEvent8 = async (queryString) => {
  const res = await api.get(`/ticket/getAllTicketsForEvent?${queryString}`, {
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getRegisteredTicketForEvent6 = async (type, params, config = {}) => {
  const res = await api.get(`/ticket/getRegisteredTicketForEvent/${type}`, {
    params,
    ...config,
  });
  return res;
};

export const getAllTicketsForEvent9 = async (type, eventId) => {
  const res = await api.get(
    `/ticket/getAllTicketsForEvent/${type}/?event_id=${eventId}`,
  );
  return res;
};

export const getRegisteredTicketForEvent7 = async (type, params) => {
  const res = await api.get(`/ticket/getRegisteredTicketForEvent/${type}`, {
    params,
  });
  return res;
};

export const deleteTicketRegistration5 = async (ticketId, submissionId, status, reason) => {
  const res = await api.delete(
    `/ticket/deleteTicketRegistration/${ticketId}/${submissionId}/${status}`,
    {
      headers: {
        "ngrok-skip-browser-warning": "true",
      },
      data: { deleteReason: reason },
    },
  );
  return res;
};

export const deleteTicketRegistration6 = async (ticketId, submissionId, status, reason, token) => {
  const res = await api.delete(`/ticket/deleteTicketRegistration/${ticketId}/${submissionId}/${status}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
    data: { deleteReason: reason },
  });
  return res;
};

export const getRegisteredTicketForEvent8 = async (type, params) => {
  const res = await api.get(`/ticket/getRegisteredTicketForEvent/${type}`, {
    params,
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getAllTicketsForEvent10 = async (eventId, type) => {
  const path =
    type === "speaker"
      ? `/ticket/getAllTicketsForEvent/speaker/?event_id=${eventId}`
      : type === "sponsor"
        ? `/ticket/getAllTicketsForEvent/sponsor/?event_id=${eventId}`
        : type === "team"
          ? `/ticket/getAllTicketsForEvent/team/?event_id=${eventId}`
          : type === "exhibitor"
            ? `/ticket/getAllTicketsForEvent/exhibitor/?event_id=${eventId}`
            : `/ticket/getAllTicketsForEvent?event_id=${eventId}`;
  const res = await api.get(path, {
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const updateTicketOfUser6 = async (payload) => {
  const res = await api.put("/ticket/updateTicketOfUser", payload);
  return res;
};

export const updateTicketOfUser7 = async (payload) => {
  const res = await api.put("/ticket/updateTicketOfUser", payload);
  return res;
};

export const getAllTicketsForEventSpeaker = async (eventId) => {
  const res = await api.get(`/ticket/getAllTicketsForEvent/speaker/`, {
    params: { event_id: eventId },
  });
  return res;
};

export const submitTicketFormSpeaker = async (formData) => {
  const res = await api.post(`/ticket/submitTicketForm/speaker`, formData, {
    transformRequest: [(d) => d],
  });
  return res;
};

export const submitTicketFormSponsor = async (formData) => {
  const res = await api.post(`/ticket/submitTicketForm/sponsor`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res;
};

export const requestDocumentExport = async (payload) => {
  const res = await api.post("/ticket/document-export", payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return res?.data;
};

export const getDocumentExportStatus = async (eventId) => {
  const res = await api.get(`/ticket/document-export/status`, {
    params: { event_id: eventId },
  });
  return res?.data;
};
